<template>
  <div class="avatars-group">
    <slot name="before"></slot>
    <v-chip
      :style="`background-color: ${bgColor};`"
      class="avatars-group__chip"
      disabled
    >
      <slot name="label">
        <strong class="avatars-group__label" v-if="label">{{ label }}</strong>
      </slot>
      <span class="avatars-group__avatars" v-if="avatars.length">
        <v-avatar
          v-for="(avatar, index) in avatars"
          :key="`${avatar}-${index}`"
          :size="avatarSize"
          class="avatars-group__avatar rounded-circle"
        >
          <img :src="avatar || require('@/assets/placeholder96x96.png')" />
        </v-avatar>
      </span>
    </v-chip>
    <slot name="after"></slot>
  </div>
</template>

<script>
export default {
  name: 'AvatarsGroup',
  components: {},
  props: {
    bgColor: {
      type: String,
      default: 'var(--bh-gray--6)',
    },
    label: {
      type: String,
      default: '',
    },
    avatarsUrls: {
      type: Array,
      default: () => [],
    },
    maxCount: {
      type: Number,
      default: 0,
    },
    avatarSize: {
      type: Number,
      default: 24,
    },
  },
  data() {
    return {}
  },
  computed: {
    maxLength() {
      return this.maxCount || this.avatarsUrls?.length
    },
    avatars() {
      return this.avatarsUrls.slice(0, this.maxLength)
    },
  },
}
</script>

<style lang="scss" scoped>
.avatars-group {
  &__avatars {
    margin-left: 10px;
  }
  &__avatar {
    & + & {
      margin-left: -4px;
    }
  }
  &__chip {
    opacity: 1 !important;
  }
}
</style>
